import axios from 'axios';

class Manager {
  constructor() {
    this.baseUrl = process.env.APP_URL + '/protocols/statistics';
    this.baseUrlUsers = process.env.APP_URL + '/users';
  }

  getClinicalCenters(perPage, page) {
    return axios.get(this.baseUrl + '/clinicalCenters', {
      params: {perPage, page},
    });
  }

  getClinicalCenter(id) {
    return axios.get(this.baseUrlUsers + '/centers/show/' + id);
  }

  getClients(clinicalCenterId, perPage, page) {
    return axios.get(this.baseUrl + '/clients/', {
      params: {
        clinicalCenterId: clinicalCenterId ? clinicalCenterId : null,
        perPage,
        page,
      },
    });
  }

  getClient(clientId) {
    return axios.get(this.baseUrlUsers + '/clients/' + clientId);
  }

  getSkillField(clientId, perPage, page, startDate, endDate, search) {
    return axios.get(this.baseUrl + '/skill-fields/', {
      params: {
        clientId,
        perPage,
        page,
        startDate,
        endDate,
        search
      },
    });
  }

  getProtocols(clientId, perPage, page, startDate, endDate, skillFieldId, search, withUndesirableBehavior) {
    return axios.get(this.baseUrl + '/protocols/' + clientId, {
      params: {
        perPage,
        page,
        startDate,
        endDate,
        skillFieldId,
        withUndesirableBehavior,
        search
      },
    });
  }

  getStatistics(clientId, perPage, page, startDate, endDate, skillFieldId, protocolId, levelLineChecked, trendLineChecked, ScatterLineChecked, graphMoYesPercentChecked, graphTotalPercentChecked, graphPromptLevelsChecked, graphImprovedSPOUChecked, graphMoYesChecked, graphProbeFullChecked, graphMoGoalChecked, graphMandReactChecked, graphGoalChecked, graphCumulativeImproveChecked, graphImprovePromptChecked, graphImproveChecked, graphCumulitiveChecked, showAbsolute, showRelative, showGraphUndesirableBehaviors,
                undesirableBehaviorGraphType, undesirableBehaviorBehaviorId) {
    return axios.get(this.baseUrl + '/' + clientId, {
      params: {
        perPage,
        page,
        startDate,
        endDate,
        skillFieldId,
        protocolId,
        levelLineChecked,
        trendLineChecked,
        ScatterLineChecked,
        graphMoYesPercentChecked,
        graphTotalPercentChecked,
        graphPromptLevelsChecked,
        graphImprovedSPOUChecked,
        graphMoYesChecked,
        graphProbeFullChecked,
        graphMoGoalChecked,
        graphMandReactChecked,
        graphGoalChecked,
        graphCumulativeImproveChecked,
        graphImprovePromptChecked,
        graphImproveChecked,
        graphCumulitiveChecked,
        showAbsolute,
        showRelative,
        showGraphUndesirableBehaviors,
        undesirableBehaviorGraphType,
        undesirableBehaviorBehaviorId
      },
    });
  }

  getEfficiency(clientId, perPage, page, startDate, endDate, skillFieldId, protocolId) {
    return axios.get(this.baseUrl + '/efficiency/' + clientId, {
      params: {
        perPage,
        page,
        startDate,
        endDate,
        skillFieldId,
        protocolId
      },
    });
  }

  getEfficiency(clientId, perPage, page, startDate, endDate, skillFieldId, protocolId) {
    return axios.get(this.baseUrl + '/efficiency/' + clientId, {
      params: {
        perPage,
        page,
        startDate,
        endDate,
        skillFieldId,
        protocolId
      },
    });
  }
}

export default new Manager();



// WEBPACK FOOTER //
// ./src/modules/reports/api/Manager.js